import React from 'react';

// Routes
import Routes from './administration-locations-routes';

export default function (props) {

  return (
   <div>
       <Routes />
   </div>
  )
}
